export default __webpack_public_path__ + "static/media/cplus-icon.4efcee93.svg";